module.exports = __webpack_public_path__ + "img/dingzhi.6f84a20b.png";